const MuiExpansionPanelDetails = {
  styleOverrides: {
    root: {
      display: 'block',
    },
  },
};

export default MuiExpansionPanelDetails;
